import { AnyAction, Reducer } from "@reduxjs/toolkit";
import storage from "reduxjs-toolkit-persist/lib/storage";
import autoMergeLevel1 from "reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel1";
import {
  persistReducer,
} from "reduxjs-toolkit-persist";
import { AppReducer } from "./rootReducer";
const persistConfig = {
    key: "root",
    storage: storage,
    stateReconciler: autoMergeLevel1,
    whitelist: ["projectData", "userProfileData","projectEditing"],
  };
  
export  const _persistedReducer: Reducer<
    ReturnType<typeof AppReducer>,
    AnyAction
  > = persistReducer<ReturnType<typeof AppReducer>, AnyAction>(
    persistConfig,
    AppReducer
  );
